import { DateTime } from 'ts-luxon'

export const formatTime = (time: string) => {
  return DateTime.fromFormat(time, 'yyyy-MM-dd HH:mm')
}

export const clamp = (min: number, value: number, max: number) => {
  return +Math.min(Math.max(value, min), max).toFixed(2)
}
